// UC Merced's undergraduate majors (#2596, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-09-30 from UC Merced's
// official 2026-2027 Catalog, Academic Programs page
// (catalog.ucmerced.edu/content.php?catoid=26&navoid=3780), which lists each
// school's Undergraduate Degrees. The catalog lists every emphasis as its own
// line ("Physics, Astrophysics Emphasis, B.S."); an emphasis is not a separate
// major, so each major and degree appears once, with its emphases in the note.
// Some majors are offered only through an emphasis (Applied Mathematical
// Sciences, for one). Minors, the Undergraduate Education programs (UCDC, UCCS,
// Honors) and graduate degrees are left out. No flags: the SJV PRIME+ BS to MD
// track is a separate application on top of four majors, not a limit on the
// majors themselves (see the college file's programs section). The KB's list
// (a community college handout) was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-merced",
    "read": "2026-09-30",
    "intro": "Every undergraduate degree in UC Merced's official 2026-2027 Catalog, grouped by the school that offers it, with the degree it leads to. Emphases are listed under their major; minors and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Engineering",
            "source": {
                "label": "UC Merced 2026-2027 Catalog, Academic Programs, School of Engineering",
                "url": "https://catalog.ucmerced.edu/content.php?catoid=26&navoid=3780"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemical and Biomolecular Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Bioengineering",
                    "degree": "B.S.",
                    "note": "Emphases: Biomedical Instrumentation; Biotechnology; Pre-Medical."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.",
                    "note": "Emphases: Aerospace; Computational; Materials Science and Engineering; Nanotechnology; Semiconductor."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "B.S.",
                    "note": "Emphasis: Artificial Intelligence."
                },
                {
                    "name": "Data Science and Analytics",
                    "degree": "B.A.",
                    "note": "Emphases: Behavioral Modeling Analytics; Business Analytics; Environment and Sustainability Analytics; Policy Analytics."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.",
                    "note": "Emphases: Computer Engineering; Electric Vehicle; Ground and Aerial Robotics; Machine Learning; Power Systems; Semiconductor Devices; Sustainable Energy."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Management of Innovation, Sustainability and Technology",
                    "degree": "B.A.",
                    "note": "Emphases: Custom; Innovation Management; Sustainability Management; Technology Management."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S.",
                    "note": "Emphases: Aerospace Materials; Computational; Nanotechnology; Semiconductor."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.",
                    "note": "Emphases: Aerospace Engineering; Agricultural Technology."
                }
            ]
        },
        {
            "name": "School of Natural Sciences",
            "source": {
                "label": "UC Merced 2026-2027 Catalog, Academic Programs, School of Natural Sciences",
                "url": "https://catalog.ucmerced.edu/content.php?catoid=26&navoid=3780"
            },
            "majors": [
                {
                    "name": "Applied Mathematical Sciences",
                    "degree": "B.S.",
                    "note": "Emphases: Computational and Data Sciences; Computational Biology; Education; Computer Science; Custom; Economics; Engineering; Environmental; Physics."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S.",
                    "note": "Emphases: Education; Pre-Pharmacy."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.A.",
                    "note": "Emphasis: Education."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S.",
                    "note": "Emphases: Developmental Biology; Education; General Biology; Human Biology; Microbiology and Immunology; Molecular and Cell Biology."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.",
                    "note": "Emphases: Biological Chemistry; Chemistry; Education; Materials Chemistry."
                },
                {
                    "name": "Data Science and Computing",
                    "degree": "B.S.",
                    "note": "Emphases: Applied Mathematics; Biology; Chemistry; Custom; Environmental Systems Science; Materials Science and Engineering; Physics."
                },
                {
                    "name": "Ecology, Evolution, and Conservation Biology",
                    "degree": "B.S.",
                    "note": "Emphases: Education; Pre-Health."
                },
                {
                    "name": "Environmental Systems Science",
                    "degree": "B.S.",
                    "note": "Emphases: Earth and Climate Science; Ecosystem Science; Education."
                },
                {
                    "name": "Physics",
                    "degree": "B.S.",
                    "note": "Emphases: Astrophysics; Biophysics and Soft Matter; Computation and Data Science; Custom; Education; Engineering and Applied Physics; Mathematical and Computational Physics; Quantum Science and Technology."
                }
            ]
        },
        {
            "name": "School of Social Sciences, Humanities and Arts",
            "source": {
                "label": "UC Merced 2026-2027 Catalog, Academic Programs, School of Social Sciences, Humanities and Arts",
                "url": "https://catalog.ucmerced.edu/content.php?catoid=26&navoid=3780"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A.",
                    "note": "Emphases: Financial Economics; Management."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A.",
                    "note": "Emphases: Cognitive Neuroscience; Computation and Cognition; Language and Culture."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.S.",
                    "note": "Emphases: Cognitive Neuroscience; Computation and Cognition; Language and Culture."
                },
                {
                    "name": "Communication and Media",
                    "degree": "B.A.",
                    "note": "Emphases: Linguistics; Media Production."
                },
                {
                    "name": "Critical Race and Ethnic Studies",
                    "degree": "B.A.",
                    "note": "Emphasis: Teaching Social Sciences."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.",
                    "note": "Emphases: Economic Analysis and Policy; Quantitative Economics."
                },
                {
                    "name": "Environmental Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Global Arts Studies",
                    "degree": "B.A.",
                    "note": "Emphases: Performance Studies; Visual Studies."
                },
                {
                    "name": "History",
                    "degree": "B.A.",
                    "note": "Emphasis: Teaching Social Sciences."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A.",
                    "note": "Emphases: Humanities and Arts; Social Science."
                },
                {
                    "name": "Literatures in English",
                    "degree": "B.A.",
                    "note": "Emphases: Literature and Social Justice; Literature and the Environment."
                },
                {
                    "name": "Management and Business Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S.",
                    "note": "Emphases: Computational, Perceptual, and Cognitive Neuroscience; Molecular, Cellular, and System Neuroscience; Neuroscience of Human Health and Development; Pre-Med."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A.",
                    "note": "Emphases: American Politics; Comparative Politics; International Relations; Law and Policy."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A.",
                    "note": "Emphases: Health Psychology; Social Psychology."
                },
                {
                    "name": "Public Health",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S.",
                    "note": "Emphasis: Pre-Med."
                },
                {
                    "name": "Science, Technology, and Ethics",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A.",
                    "note": "Emphases: Community Studies; Health, Medicine, and Society; Justice, Law, and Society; Race and Racial Justice."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Writing Studies",
                    "degree": "B.A.",
                    "note": "Emphasis: Creative Writing."
                }
            ]
        }
    ]
};

export default majors;
